import { useCallback, useMemo } from 'react';

import { useTaxFormsBannerQuery } from '../queries';

const useTaxFormBanner = () => {
  const { isSuccess, isDisplayed, handleDismiss } = useTaxFormsBannerQuery();

  const isBannerDisplayed = useMemo(() => isSuccess && isDisplayed, [isDisplayed, isSuccess]);

  const handleDismissBanner = useCallback(async () => {
    await handleDismiss();
  }, [handleDismiss]);

  return {
    isDisplayed: isBannerDisplayed,
    handleDismiss: handleDismissBanner,
  };
};

export default useTaxFormBanner;
